"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _reactI18next = require("react-i18next");
var _Checkbox = _interopRequireDefault(require("../Checkbox"));
var _RemoveCircle = _interopRequireDefault(require("@material-ui/icons/RemoveCircle"));
var SelectAllThreads = function SelectAllThreads(_ref) {
  var label = _ref.label,
    checked = _ref.checked,
    universeChecked = _ref.universeChecked,
    numSelected = _ref.numSelected,
    numUniverse = _ref.numUniverse,
    onSelect = _ref.onSelect,
    onSelectUniverse = _ref.onSelectUniverse,
    isSelected = _ref.isSelected,
    onCancel = _ref.onCancel;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var message = t('threadList.selectAllThreads.selectAll');
  if (checked && universeChecked) {
    message = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
      i18nKey: "threadList.selectAllThreads.numUniverse",
      count: numSelected
    }, "All ", {
      numUniverse: numUniverse
    }, " threads in ", {
      label: label
    }, " are selected."), /*#__PURE__*/_react["default"].createElement("span", {
      className: "text-primary cursor-pointer ml-1 font-bold",
      onClick: onCancel
    }, t('threadList.selectAllThreads.cancel')));
  } else if (checked) {
    var displaySelectUniverse = !(0, _isNil["default"])(onSelectUniverse) && numSelected < numUniverse;
    message = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
      i18nKey: "threadList.selectAllThreads.numSelected",
      count: numSelected
    }, "You've selected ", {
      numSelected: numSelected
    }, " threads."), displaySelectUniverse && /*#__PURE__*/_react["default"].createElement("span", {
      className: "ml-1 font-bold cursor-pointer text-primary",
      onClick: onSelectUniverse
    }, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
      i18nKey: "threadList.selectAllThreads.selectUniverse"
    }, "Select all ", {
      numUniverse: numUniverse
    }, " threads in ", {
      label: label
    }, ".")));
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center pl-1"
  }, isSelected && !checked ? null : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    checked: checked,
    onChange: onSelect,
    name: "Select All Threads"
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-xs"
  }, message)), isSelected && !checked && /*#__PURE__*/_react["default"].createElement(_RemoveCircle["default"], {
    className: "text-primary ml-2 cursor-pointer",
    onClick: function onClick() {
      if (onCancel) {
        onCancel();
      }
    }
  }));
};
var _default = exports["default"] = SelectAllThreads;
//# sourceMappingURL=SelectAllThreads.js.map